<div class="property-expand-panel mt-2">
  <div class="d-flex align-items-center mb-2">
    <label class="reveal-label">
      {{ 'Administration::RedactionSettings:RevealCharacters' | abpLocalization }}
    </label>
    <i
      class="c-pointer fa-solid fa-info-circle color-gray-500"
      [ngbTooltip]="'Administration::RedactionSettings:RevealCharactersTooltip' | abpLocalization"
      placement="right"
      container="body"
    ></i>
  </div>
  <div class="d-flex align-items-center">
    <div class="btn-group reveal-toggle" role="group">
      <button
        type="button"
        class="btn btn-sm"
        [class.active]="revealMode === RevealMode.Start"
        [disabled]="isReadOnly"
        (click)="onRevealModeChanged(RevealMode.Start)"
      >
        {{ 'Administration::RedactionSettings:RevealStart' | abpLocalization }}
      </button>
      <button
        type="button"
        class="btn btn-sm"
        [class.active]="revealMode === RevealMode.Off"
        [disabled]="isReadOnly"
        (click)="onRevealModeChanged(RevealMode.Off)"
      >
        {{ 'Administration::RedactionSettings:RevealOff' | abpLocalization }}
      </button>
      <button
        type="button"
        class="btn btn-sm"
        [class.active]="revealMode === RevealMode.End"
        [disabled]="isReadOnly"
        (click)="onRevealModeChanged(RevealMode.End)"
      >
        {{ 'Administration::RedactionSettings:RevealEnd' | abpLocalization }}
      </button>
    </div>
    @if (revealMode !== RevealMode.Off) {
      <input
        type="number"
        class="form-control form-control-sm reveal-count-input"
        min="0"
        max="10"
        [ngModel]="revealCount"
        [disabled]="isReadOnly"
        (ngModelChange)="onRevealCountChanged($event)"
      />
    }
  </div>
</div>
